var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamilymember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 10.0832C11.9167 8.05813 10.275 6.4165 8.24999 6.4165C6.22495 6.4165 4.58333 8.05813 4.58333 10.0832C4.58333 12.1082 6.22495 13.7498 8.24999 13.7498C10.275 13.7498 11.9167 12.1082 11.9167 10.0832Z",
    stroke: "#171615",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1187 6.92792C10.0953 6.76085 10.0833 6.59016 10.0833 6.41667C10.0833 4.39162 11.725 2.75 13.75 2.75C15.775 2.75 17.4167 4.39162 17.4167 6.41667C17.4167 8.44171 15.775 10.0833 13.75 10.0833C13.0674 10.0833 12.4285 9.89688 11.8813 9.57211",
    stroke: "#171615",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 19.25C13.75 16.2124 11.2876 13.75 8.25 13.75C5.21243 13.75 2.75 16.2124 2.75 19.25",
    stroke: "#171615",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 15.5835C19.25 12.5459 16.7876 10.0835 13.75 10.0835",
    stroke: "#171615",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilymember);
export default __webpack_public_path__ + "static/media/familymember.fd49aca07fb49f43686f0a32a703f9b5.svg";
export { ForwardRef as ReactComponent };